import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

import { CommonService } from "../common/common.service";
import { EventBusService, EventsEnum } from "../common/event-bus.service";

@Component({
    templateUrl: "./contact.component.html",
    styleUrls: ["./contact.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactComponent implements OnInit {
  showAnimation : boolean = false;
  constructor(
    private _commonService: CommonService,
    private _route: ActivatedRoute,
    private _events: EventBusService
  ) {
    this._commonService.shuffelAbout.subscribe(()=>{      
      this.showAnimation = true;
    });
    this._commonService.shuffelHome.subscribe(()=>{      
      this.showAnimation = true;
    });
  }

  ngOnInit(): void {
    this._route.data.subscribe((data) => {
      this._events.emit({ name: EventsEnum.RouteChanged, data });
    });

    this._commonService.pageTitle = "Contact Us";
    this._commonService.pageSubTitle = "";

    this._commonService
      .activateController([], "contact")
      .then((results) => results)
      .catch((error) => console.error(error));
  }
}
